import { z } from "zod";

// `propagationId` is present when the flow is opened to edit an existing
// propagation (from the Stories index). `groupType`/`groupName` carry the
// target group across the pilot -> collection boundary for the breadcrumb.
export const collectionFlowSearchSchema = z.object({
  propagationId: z.string().optional(),
  groupType: z.enum(["collection", "category", "tag"]).optional(),
  /** Display name of the target group, shown in the flow breadcrumb. */
  groupName: z.string().optional(),
});

export const pilotFlowSearchSchema = collectionFlowSearchSchema.extend({
  groupId: z.string().or(z.number()).optional(),
  allProducts: z.boolean().optional(),
});

// Step-to-step navigations set only `params`, which would drop every search
// key on the first click; each flow route retains its whole schema.
export function searchKeys<T extends z.ZodRawShape>(
  schema: z.ZodObject<T>,
): (keyof T & string)[] {
  return Object.keys(schema.shape) as (keyof T & string)[];
}
